import React, { useState } from 'react';
import { Alert } from 'reactstrap';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { sendEventGA } from '../../../lib/analytics';
import { getAffiliateCookieFromStorage } from '../../../helpers/affiliateTracking';
import Loader from '../../Common/Loader';
import axios from 'axios';

const DEFAULT_ERROR =
  'Si è verificato un errore durante il processamento del pagamento, per favore riprova più tardi.';

const CheckoutForm = ({ onPaymentSuccess, endpoint, data }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const isFree = data.discountCode && data.discountCode.isFree;

  // Get affiliate data if present
  const affiliateData = getAffiliateCookieFromStorage();

  const handlePayment = async () => {
    setError('');
    setIsProcessing(true);

    // For free subscriptions, use the free subscription endpoint
    if (isFree) {
      try {
        const requestData = {
          ...data,
          ...(affiliateData && { affiliateData }),
        };

        await axios.post(
          `https://us-central1-${process.env.REACT_APP_PROJECTID}.cloudfunctions.net/api${endpoint}`,
          requestData,
        );

        setSuccess(true);
        onPaymentSuccess();
        setIsProcessing(false);
        return;
      } catch (err) {
        setError("Errore durante l'attivazione del piano gratuito");
        setIsProcessing(false);
        return;
      }
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setIsProcessing(false);
      return;
    }

    try {
      // Include affiliate data in the request if present
      const requestData = {
        ...data,
        ...(affiliateData && { affiliateData }),
      };

      const response = await axios.post(
        `https://us-central1-${process.env.REACT_APP_PROJECTID}.cloudfunctions.net/api${endpoint}`,
        requestData,
      );
      const { clientSecret } = response.data;

      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}${window.location.pathname}?payment_success`,
        },
        redirect: 'if_required',
      });

      if (error) {
        setError(error.message || DEFAULT_ERROR);
        setSuccess(false);
        sendEventGA('purchase_failed', {
          userId: data.userId,
          error: error.message || DEFAULT_ERROR,
        });
      } else if (paymentIntent?.status === 'succeeded') {
        setError('');
        setSuccess(true);
        onPaymentSuccess();
      } else {
        setError(DEFAULT_ERROR);
        setSuccess(false);
      }

      setIsProcessing(false);
    } catch (error) {
      setError(DEFAULT_ERROR);
      setIsProcessing(false);
    }
  };

  return (
    <div className="position-relative">
      {isProcessing && <Loader size={4} top={150} />}
      {error && <Alert color="danger">{error}</Alert>}
      {!success && (
        <>
          {!isFree && <PaymentElement />}
          {isFree && (
            <Alert color="info" className="mb-3">
              <i className="bx bx-info-circle mr-2"></i>
              Il tuo piano è gratuito! Clicca su "Attiva Piano" per completare
              l'attivazione.
            </Alert>
          )}
          <button
            type="button"
            className="btn btn-success btn-rounded btn-block waves-effect waves-light font-size-18 my-3 px-2"
            onClick={handlePayment}
            disabled={isProcessing}>
            {isProcessing
              ? 'Sto processando...'
              : isFree
              ? 'Attiva Piano Gratuito'
              : 'Paga ora'}
          </button>
        </>
      )}
    </div>
  );
};

export default CheckoutForm;
